import { BookmarkCategory, Enum_Bookmark_Category, FetchMyBookmarksQueryVariables } from '@edwin-group/cj-graphql';

export function buildBookmarkFilters({
  category,
  resourceType,
}: {
  category?: Enum_Bookmark_Category;
  resourceType?: string;
}): FetchMyBookmarksQueryVariables {
  const filters: FetchMyBookmarksQueryVariables = {} as FetchMyBookmarksQueryVariables;

  if (category) {
    filters.category = category as unknown as BookmarkCategory;
  }

  if (resourceType) {
    filters.resourceType = resourceType;
  }

  return filters;
}
